<template>
  <ui-dialog
    v-if="show"
    :show="show"
    persistent
    scrollable
    :closable="false"
    max-width="542"
    @input="$emit('close')"
  >
    <template #header>
      <h3>
        {{ $t("message.reviews.categories.sentimentChange") }}
      </h3>
    </template>
    <template #default>
      <p class="alert-text">
        {{ $t("message.reviews.categories.sentimentChangeAlert") }}
      </p>
    </template>

    <template #actions>
      <div class="d-flex justify-end w-100">
        <ui-button outlined color="primary" @click="$emit('close')">
          {{ $t("message.common.cancel") }}
        </ui-button>
        <ui-button
          class="ml-2"
          color="primary"
          outlined
          @click="$emit('confirm')"
        >
          {{ $t("message.reviews.categories.makeChange") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "SentimentChangeAlert",
  props: {
    show: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.alert-text {
  color: $dark-blue-3;
  @include font-size(16px);
}
</style>
